export default function() {
    if($('.parallax-image').length > 0) {

    }
}